import { IStyleState } from 'lib/layouts/BrandedDashboardLayout/DashboardLayout.types'
import { createStyles } from 'utils/css'
import theme from 'utils/theme'
import { ColorProps } from 'utils/types'

const { colors, radii } = theme

export const navWrapper = (isMobile: boolean, brandColor: ColorProps) =>
  createStyles(({ colors, justifications, radii, spacing }) => ({
    backgroundColor: !brandColor ? colors.primary : colors.light,
    color: !brandColor ? colors.light : colors.grey25,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: justifications.between,
    flex: 'unset',
    width: '100%',
    ul: {
      paddingRight: spacing(0.75)
    },
    li: {
      width: '100%',
      marginBottom: spacing(0.75),
      fontSize: '15px',
      div: {
        width: '100%'
      },
      a: {
        alignItems: 'center',
        width: '100%',
        display: 'flex',
        padding: spacing([0.25, 0.25, 0.25, 0.75]),
        textDecoration: 'none',
        '&:hover': {
          color:
            !brandColor || brandColor?.isDark ? colors.light : colors.grey25,
          background: brandColor?.hex || colors.purple25,
          borderRadius: `0 ${radii.lg} ${radii.lg} 0`,
          cursor: 'pointer'
        }
      },
      '& svg': {
        marginRight: spacing(0.75)
      }
    },

    '.active': {
      background: brandColor?.hex || colors.purple25,
      color: !brandColor || brandColor?.isDark ? colors.light : colors.grey25,
      borderRadius: `0 ${radii.lg} ${radii.lg} 0`
    },
    button: {
      textDecoration: 'none'
    }
  }))

export const subnav = (brandColor: ColorProps) =>
  createStyles(({ colors, fontSizes, radii, spacing }) => ({
    marginBottom: 0,
    width: '100%',
    borderRadius: `0 ${radii.lg} ${radii.lg} 0`,

    '& button': {
      borderRadius: `0 ${radii.lg} ${radii.lg} 0`,
      padding: spacing([0.25, 0, 0.25, 0]),
      fontSize: '15px'
    },
    '& nav': {
      overflow: 'hidden'
    },
    '& ul': {
      padding: 0
    },

    '& li': {
      margin: spacing([0.5, 0, 0.5, 0.4]),
      width: 'auto',
      lineHeight: 1,
      position: 'relative',

      a: {
        fontSize: fontSizes.sm,
        padding: spacing([0.25, 0.25, 0.25, 0.5]),
        fontWeight: 'normal'
      }
    },
    '.activeBorder': {
      position: 'absolute',
      left: 0,
      top: 5,
      height: '12px',
      width: '3px',
      background: !brandColor
        ? colors.grey20
        : brandColor.isDark
        ? colors.grey15
        : colors.grey25
    },
    '.active': {
      a: {
        fontWeight: 'bold'
      }
    }
  }))

export const hoverTreatment = ({
  brandColor,
  isActive
}: Pick<IStyleState, 'brandColor' | 'isActive'>) =>
  !isActive
    ? {
        '&:hover': {
          color:
            !brandColor || brandColor?.isDark ? colors.light : colors.grey25,
          background: brandColor?.hex || colors.primary,
          borderRadius: `0 ${radii.lg} ${radii.lg} 0`,
          cursor: 'pointer'
        }
      }
    : {}

export const activeTreatment = ({
  brandColor,
  isActive
}: Pick<IStyleState, 'brandColor' | 'isActive'>) =>
  isActive
    ? {
        background: brandColor?.hex || colors.primary,
        color: !brandColor || brandColor?.isDark ? colors.light : colors.grey25,
        borderRadius: `0 ${radii.lg} ${radii.lg} 0`
      }
    : {}

export const subnavContainer = ({
  isActive,
  brandColor
}: Pick<IStyleState, 'brandColor' | 'isActive'>) =>
  createStyles(({ spacing }) => ({
    padding: spacing([0.1, 0, 0.1, 0.75]),
    ...hoverTreatment({ brandColor, isActive }),
    ...activeTreatment({ brandColor, isActive })
  }))
